import React, { useState, useEffect } from 'react';
import { Text, Grid, TextField, Button, Icon, Alert, useTheme, ScrollView, Table, TableHead, TableCell, TableRow, TableBody, Input } from '@aws-amplify/ui-react';
import { MdClose } from 'react-icons/md';
import { Loader } from '@aws-amplify/ui-react';
import { generateClient } from 'aws-amplify/api';
import { listUserProjects } from './graphql/queries';

const client = generateClient();

const HomeViewPageProject = ({ selectProject, onCancel, role }) => {
    const [name, setName] = useState('');
    const [path, setPath] = useState('');
    const [metadataValue, setMetadataValue] = useState('');
    const [isSuccessOpen, setisSuccessOpen] = useState(false);
    const [isView, setIsView] = useState(true);
    const [isTemporal, setIsTemporal] = useState(true);
    const [temporalComponent, setTemporalComponent] = useState();
    const [mapping, SetMapping] = useState([]);

    const { tokens } = useTheme();

    const handlerLoader = () => {
        const loaderTimeout = setTimeout(() => {
            setIsTemporal(false);
        }, 1000);

        setTemporalComponent(
            <Loader
                variation="linear"
                emptyColor={tokens.colors.gray}
                filledColor={'#588292'}
            />)
    }

    const handlerTemporal = (type) => {
        if (type === 'loader') {
            handlerLoader();
        }
    }

    useEffect(() => {
        setName(selectProject.name);
        setPath(selectProject.path);
        const jsonObjectMapping = JSON.parse(selectProject.mapping);
        const jsonObjectMappingList = Object.entries(jsonObjectMapping).map(([key, value]) => ({
            key: key,
            ...value
        }));
        SetMapping(jsonObjectMappingList);

        if (selectProject.metadata) {
            setMetadataValue("Sí");
        } else {
            setMetadataValue("No");
        }
    }, []);

    const handlersOnCancel = () => {
        onCancel();
    }

    const handleSubmit = (projectData) => {
        setName(projectData.name);
        setPath(projectData.path);
        if (projectData.metadata) {
            setMetadataValue("Sí");
        } else {
            setMetadataValue("No");
        }

        setTimeout(() => {
            setisSuccessOpen(false);
        }, 5000);

        setisSuccessOpen(true);
        setIsView(true);
    };

    useEffect(() => {
        handlerTemporal("loader");
    }, [selectProject]);

    return (
        <>
            {isView ? (
                <>
                    {isSuccessOpen && <><Alert
                        variation="success"
                        heading="Proyecto actualizado correctamente"
                        isDismissible
                    ></Alert><br /></>}
                    <Grid
                        templateColumns="5fr 1fr"
                        templateRows="2rem"
                    >
                        <Button
                            variation="primary"
                            colorTheme="success"
                            onClick={handlersOnCancel}
                            className='button-back'
                        >
                            <Icon
                                as={MdClose} aria-hidden="true"
                            />
                        </Button>
                    </Grid>
                    {isTemporal ? (
                        <Grid
                            templateColumns="10fr"
                            templateRows="12rem"
                        >
                            <div>

                            </div>
                            {temporalComponent}
                        </Grid>
                    ) :
                        (
                            <>

                                <Grid
                                    templateColumns="6fr 1fr"
                                    templateRows="4rem"
                                >
                                    <div className='div-text'>
                                        <Text className="labels-titles">Ruta del proyecto</Text>
                                        <TextField className='values'
                                            defaultValue={path}
                                            isReadOnly={true}
                                            size="small"
                                            variation="quiet"
                                        />
                                    </div>
                                    <div className='div-text'>
                                        <Text className="labels-titles">¿Requiere medatada?</Text>
                                        <Text className="values">{metadataValue}</Text>
                                    </div>

                                </Grid>
                                <div className='div-text'>
                                    <Text className="labels-titles">Nombre</Text>
                                    <TextField className='values'
                                        defaultValue={name}
                                        isReadOnly={true}
                                        size="small"
                                        variation="quiet"
                                    />

                                </div>
                                <>
                                    <div className='div-text'>
                                        <Text className="labels-titles-users">Mapeo de datos de la Metadata</Text>
                                        {mapping.length > 0 && <Text
                                                    textAlign={'center'}
                                                    color='#ffffff'
                                                    fontSize='0.8rem'
                                                    >
                                                    La columna que corresponde al nombre del audio es: <b Style="color: #901414ed;">{mapping[0].column_name_audio}</b>
                                                </Text>
                                        }
                                        <div className='div-text'>
                                            {mapping.length > 0 ? (
                                                <>
                                                    <ScrollView height="136px" width="450px" maxWidth="100%">
                                                        <Table
                                                            caption=""
                                                            highlightOnHover={false}
                                                            size="small">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell as="th" color={'white'}>Datos ressolve</TableCell>
                                                                    <TableCell as="th" color={'white'}>Datos cliente</TableCell>
                                                                    <TableCell as="th" color={'white'}>Valores posibles</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {mapping.map((mapping) => (
                                                                    <TableRow key={mapping.id}>
                                                                        <TableCell
                                                                            colSpan="1"
                                                                        >
                                                                            <Input
                                                                                id={`key-${mapping.id}`}
                                                                                size="small"
                                                                                defaultValue={mapping.key}
                                                                                readOnly={true}
                                                                                className='input-mapping-home'
                                                                                color={'white'}
                                                                            />
                                                                        </TableCell>
                                                                        <TableCell
                                                                            colSpan="1"
                                                                        >
                                                                            <Input
                                                                                size="small"
                                                                                id={`client-column-${mapping.id}`}
                                                                                defaultValue={mapping.client_column}
                                                                                readOnly={true}                                                                                // onClick={handleInputClick}
                                                                                className='input-mapping-home'
                                                                                color={'white'}
                                                                            />
                                                                        </TableCell>
                                                                        <TableCell
                                                                            colSpan="1"
                                                                        >
                                                                            <Input
                                                                                size="small"
                                                                                id={`possible-values-${mapping.id}`}
                                                                                defaultValue={mapping.client_possible_values}
                                                                                readOnly={true}
                                                                                className='input-mapping-home'
                                                                                color={'white'}
                                                                            />
                                                                        </TableCell>
                                                                    
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </ScrollView>
                                                </>) : (
                                                <Text
                                                    textAlign={'center'}
                                                    color='#901414ed'>
                                                    Este proyecto no
                                                    tiene mapeo de datos
                                                </Text>)}

                                        </div>
                                    </div>
                                </>
                            </>
                        )}
                </>
            ) : (
                <>
                </>
            )}
        </>
    );
};

export default HomeViewPageProject;
